type ChipStyle = {
  backgroundColor: string;
};

export const stringToHSL = (() => {
  const cache: { [key: string]: ChipStyle } = {};

  return (str: string): ChipStyle => {
    if (cache[str]) {
      return cache[str];
    }

    let hash = 0;
    let s = 0;
    let l = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      s = hash << 5;
      l = (hash << 5) - hash;
    }

    const hue = hash % 360;
    const saturation = 60 + (s % 20);
    const lightness = 50 + (l % 20);

    const backgroundColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    const chipStyle = { backgroundColor };

    cache[str] = chipStyle;
    return chipStyle;
  };
})();
